var _path, _path2, _polygon, _polygon2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoryLane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.01,
    y: 280.97,
    width: 5.62,
    height: 42.05,
    transform: "translate(185.83 789.82) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.53,299.42a13.43,13.43,0,0,1,0,5.26,12.94,12.94,0,0,1,0-5.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.61,299.31a13.43,13.43,0,0,1,0,5.26,13.43,13.43,0,0,1,0-5.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.59,299.42a12.94,12.94,0,0,1,0,5.26,13.43,13.43,0,0,1,0-5.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 504.68,
    cy: 301.94,
    rx: 0.26,
    ry: 2.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.18,302.17c0,.14-4.81.26-10.75.26s-10.76-.12-10.76-.26a107.16,107.16,0,0,1,10.76-.27A106.87,106.87,0,0,1,499.18,302.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 482.02,
    y: 309.07,
    width: 11.23,
    height: 42.05,
    transform: "translate(157.55 817.73) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.2,332.55a1,1,0,0,1-.23.13c-.15.08-.39.19-.7.32a12,12,0,0,1-2.85.82,7.38,7.38,0,0,1-4.62-.66,6.11,6.11,0,0,1-2.2-2,4.64,4.64,0,0,1-.77-3.24,3.38,3.38,0,0,1,.78-1.67,2.17,2.17,0,0,1,1.77-.8,2.53,2.53,0,0,1,1.78,1,3.47,3.47,0,0,1,.82,1.91,5.13,5.13,0,0,1-1.45,4,6.44,6.44,0,0,1-4,2,10.83,10.83,0,0,1-4.7-.58A8.69,8.69,0,0,1,488.7,331a4.49,4.49,0,0,1-1-2.42,3.15,3.15,0,0,1,.9-2.53,2,2,0,0,1,1.31-.57,2.36,2.36,0,0,1,1.38.38,3.64,3.64,0,0,1,1.54,2.27,5.29,5.29,0,0,1-1.65,4.95,8.3,8.3,0,0,1-4.74,1.93,11.77,11.77,0,0,1-4.91-.49,6.78,6.78,0,0,1-3.73-2.9,5,5,0,0,1-.47-4.46,2.34,2.34,0,0,1,1.72-1.45,2.66,2.66,0,0,1,2.12.51,3.52,3.52,0,0,1,1,3.78,6.57,6.57,0,0,1-2.12,3,9.64,9.64,0,0,1-5.77,2.24,9.26,9.26,0,0,1-4.56-1,9,9,0,0,1-2.39-1.77,5.75,5.75,0,0,1-.5-.58c-.11-.14-.16-.21-.15-.22a10.7,10.7,0,0,0,3.13,2.39,9.15,9.15,0,0,0,4.46.92,9.26,9.26,0,0,0,5.54-2.23,6.16,6.16,0,0,0,2-2.81,3.09,3.09,0,0,0-.88-3.32,2.25,2.25,0,0,0-1.76-.42,1.88,1.88,0,0,0-1.38,1.19,4.51,4.51,0,0,0,.46,4,6.26,6.26,0,0,0,3.48,2.67,11,11,0,0,0,4.69.45,7.71,7.71,0,0,0,4.43-1.8,4.77,4.77,0,0,0,1.5-4.44,3.13,3.13,0,0,0-1.31-1.94,1.61,1.61,0,0,0-2.05.13,2.6,2.6,0,0,0-.74,2.1,4,4,0,0,0,.85,2.15,8.18,8.18,0,0,0,3.85,2.59,10.31,10.31,0,0,0,4.47.57,5.93,5.93,0,0,0,3.76-1.8,4.7,4.7,0,0,0,1.35-3.62,2.69,2.69,0,0,0-2.18-2.52,1.83,1.83,0,0,0-1.46.66,3.12,3.12,0,0,0-.7,1.48,4.29,4.29,0,0,0,.68,3,5.84,5.84,0,0,0,2.06,1.91,7.23,7.23,0,0,0,4.45.71,13.26,13.26,0,0,0,2.84-.71C508.87,332.67,509.19,332.53,509.2,332.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.77,
    y: 295.57,
    width: 19.49,
    height: 38.29,
    transform: "translate(174.8 804.23) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.73,305.64a82.3,82.3,0,0,1,.27,9.43,82.3,82.3,0,0,1-.27,9.43,86.79,86.79,0,0,1-.26-9.43A86.79,86.79,0,0,1,476.73,305.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.64,305.39a84.65,84.65,0,0,1,.26,9.31,84.77,84.77,0,0,1-.26,9.32,80.39,80.39,0,0,1-.27-9.32A80.28,80.28,0,0,1,479.64,305.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.33,304.77a88.94,88.94,0,0,1,.27,9.8,89,89,0,0,1-.27,9.81,93.9,93.9,0,0,1-.26-9.81A93.78,93.78,0,0,1,504.33,304.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.92,305a84.5,84.5,0,0,1,.27,9.55,84.61,84.61,0,0,1-.27,9.56,86.19,86.19,0,0,1-.26-9.56A86.07,86.07,0,0,1,500.92,305Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.39,
    y: 83.06,
    width: 258.14,
    height: 171.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.22,95.57A43.74,43.74,0,1,1,80.66,138.8,43.9,43.9,0,0,1,36.22,95.57Zm64.64-1a20.91,20.91,0,1,0-20.57,21.35A21,21,0,0,0,100.86,94.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.22,95.57a43.9,43.9,0,0,1,43-44.64l.37,22.92a21,21,0,0,0,.67,42l.37,22.93A43.89,43.89,0,0,1,36.22,95.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.32,47.4c28.22-.46,50.72,21.44,51.17,49.78l-26.7.43c-.21-13.55-10.52-22.08-24-21.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.45,448c-1.12-1-3.63-4-1.69-7.57.7-1.3,2.21-1.94,3.57-2.52a14.37,14.37,0,0,0,3.93-2c2.12-1.81,2.71-4.82,4.12-7.23,1.62-2.77,4.65-4.85,7.84-4.7,3.66.17,6.71,3.15,8.1,6.56s1.43,7.2,1.46,10.88c0,2-.08,4.33-1.57,5.7s-3.45,1.28-5.32,1.23l-20-.62",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.71,393h-52.6l9.47,56.5a6.31,6.31,0,0,0,4.49,5l.19.05c.15,0,.31.09.47.12a7.28,7.28,0,0,0,1.07.13v.05l.26,0h23.45a6.69,6.69,0,0,0,1.28-.13,6.33,6.33,0,0,0,5.32-5.52l4.57-38.93.21-1.55h0l1.81-15.41Zm-9.93,36h-5.39l.54-16.39h6.25Zm1.93-16.39h5.17L279,429h-4.64Zm-15.42,34.57L260,432.94h7.77l-.47,14.25Zm-8.41-14.25h7.56l.33,14.25H253Zm.59,14.25h-6.33c-.61-3.85-1.39-8.85-2.24-14.25h7.46ZM251.58,429l-1.28-16.39H259l.38,16.39Zm8.29,0-.38-16.39h8.92L267.86,429Zm-.47-20.33-.35-15.18h10l-.5,15.18Zm-.52,0H250l-1.18-15.18h9.71Zm-9.4,0h-9.4c-.33-2.09-.65-4.08-.93-5.86-1-6.14-1.35-8.45-1.56-9.32H248.3Zm.3,3.94L251.06,429h-7.77c-.27-1.66-.53-3.34-.8-5-.6-3.87-1.21-7.74-1.79-11.36Zm-7,16.39h-5.08l-2.75-16.39h5.24C241,417.68,241.86,423.32,242.76,429Zm.61,3.93c.78,4.93,1.54,9.79,2.24,14.25h-4.88l-2.39-14.25Zm24.41,14.25.48-14.25h5.19l-1.22,14.25Zm1.28-38.51.51-15.18h7.25l-1.3,15.18Zm-32-15.18c.21,1.1,1.17,7.07,2.45,15.18h-5.28l-2.54-15.18Zm39.72,53.69h-4.06L274,432.94h4.52Zm4.52-38.51H276l1.3-15.18h5.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.01,
    y: 109.74,
    width: 11.33,
    height: 45.24,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669.67,
    y: 119.61,
    width: 11.33,
    height: 35.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.58,
    y: 127.69,
    width: 11.33,
    height: 27.29,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.23,
    y: 138.78,
    width: 11.33,
    height: 16.21,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.33,211.25a39.18,39.18,0,0,0-55.09,1.86,38.63,38.63,0,0,0,1.87,54.77,39.19,39.19,0,0,0,55.1-1.87A38.62,38.62,0,0,0,695.33,211.25Zm-13,41a18.74,18.74,0,0,1-26.34.89,18.48,18.48,0,0,1-.9-26.19,18.76,18.76,0,0,1,26.35-.89A18.47,18.47,0,0,1,682.34,252.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.24,213.11a39.18,39.18,0,0,1,55.09-1.86L681.45,226a18.76,18.76,0,0,0-26.35.89,18.48,18.48,0,0,0,.9,26.19l-13.89,14.78A38.63,38.63,0,0,1,640.24,213.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.74,204.91c19.24,17.87,21.55,46.92,3.57,66L677.79,254c8.6-9.14,10.46-21.35,1.26-29.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.4,
    y: 275.34,
    width: 110.45,
    height: 31.11,
    rx: 3.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.43,
    cy: 291.86,
    rx: 6.73,
    ry: 6.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.21,289.56a27.84,27.84,0,0,1-3.62,3.91c-.3.3-.6.58-.89.86l-.18.18-.17-.18a18.8,18.8,0,0,1-2.7-3.07,19.43,19.43,0,0,1,3.06,2.71h-.36l.88-.87A27.63,27.63,0,0,1,187.21,289.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,288.52c0,.14-14.83.26-33.11.26s-33.11-.12-33.11-.26,14.82-.26,33.11-.26S265,288.37,265,288.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.27,294.15c0,.15-14.83.26-33.11.26s-33.11-.11-33.11-.26,14.82-.26,33.11-.26S265.27,294,265.27,294.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "614.07 298.25 612.05 455.25 702.38 455.25 702.38 300.39 614.07 298.25",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "662.74 299.43 661.94 455.25 702.38 455.25 702.38 300.39 662.74 299.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "616.91 301.08 616.91 333.19 659.7 333.19 659.7 302.6 616.91 301.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.66 309.91 631.66 314.66 644.75 314.66 644.75 309.48 631.66 309.91",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.66,
    y: 318.64,
    width: 13.52,
    height: 1.94,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "616.91 413.61 616.91 445.72 659.7 445.72 659.7 415.13 616.91 413.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.66 422.44 631.66 427.19 644.75 427.19 644.75 422.01 631.66 422.44",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.66,
    y: 431.17,
    width: 13.52,
    height: 1.94,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "616.91 337.28 616.91 369.39 659.7 369.39 659.7 338.8 616.91 337.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.66 346.11 631.66 350.86 644.75 350.86 644.75 345.68 631.66 346.11",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.66,
    y: 354.84,
    width: 13.52,
    height: 1.94,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.35,
    y: 375.73,
    width: 42.79,
    height: 32.11,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.39 390.2 631.39 394.66 643.7 394.66 643.7 389.8 631.39 390.2",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.39,
    y: 398.41,
    width: 12.71,
    height: 1.82,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M705.78,453.89c0,.15-148.11.26-330.76.26s-330.8-.11-330.8-.26,148.08-.26,330.8-.26S705.78,453.75,705.78,453.89Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screens--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.92,
    y: 87.35,
    width: 267.33,
    height: 175.35,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.25,262.7c0-1.69-.08-68.4-.21-175.35l.21.21-267.31,0h0l.26-.26c0,62.36,0,121.7,0,175.35l-.24-.24,267.33.24-267.33.24h-.24v-.24c0-53.65,0-113,0-175.35v-.26h.28l267.31.06h.21v.2C494.33,194.3,494.25,261,494.25,262.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.62,184.18l26.29.37c-.2,14-12,25.43-26.29,25.43h-.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.1,219.79a3.22,3.22,0,0,1-.57,0l-1.6,0-5.88.07H344l-.05-.06c-2.35-2.95-5.37-6.77-8.67-10.93l-7-8.91.14.06-7.74-.07L318.5,200a3.6,3.6,0,0,1-.77,0,4.69,4.69,0,0,1,.77-.05l2.16,0,7.74-.07h.08l0,.06,7,8.89,8.6,11-.12-.06,5.88.07,1.6,0A2.6,2.6,0,0,1,352.1,219.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.53,222.82c0,.11-3.81.2-8.51.2s-8.51-.09-8.51-.2,3.81-.2,8.51-.2S361.53,222.71,361.53,222.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.53,226c0,.11-3.81.2-8.51.2s-8.51-.09-8.51-.2,3.81-.2,8.51-.2S361.53,225.86,361.53,226Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.46,180.44l-.37,25.8c-14.28-.2-25.93-11.78-25.93-25.8s11.87-25.79,26.3-25.79,26.3,11.64,26.3,25.79Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.19,172a1.88,1.88,0,0,1-.45.1l-1.31.21-4.72.67h-.08l-.06-.06-6.3-6.13c-3-3-5.75-5.67-7.71-7.64l-2.3-2.35a6.85,6.85,0,0,1-.81-.9,6.42,6.42,0,0,1,.92.79l2.39,2.25c2,1.92,4.76,4.59,7.79,7.56l6.25,6.18-.14,0,4.75-.52,1.31-.12A1.29,1.29,0,0,1,294.19,172Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.79,154.78c0,.11-3.81.2-8.51.2s-8.5-.09-8.5-.2,3.8-.2,8.5-.2S263.79,154.67,263.79,154.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.79,157.93c0,.11-3.81.2-8.51.2s-8.5-.09-8.5-.2,3.8-.2,8.5-.2S263.79,157.82,263.79,157.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.45,129.48l-.1-16a20.5,20.5,0,0,0-13.23,5.16,19,19,0,0,0-6.37,16.6,22.13,22.13,0,0,0,.38,2.33.13.13,0,0,0,0,.06h0l19.31-4.35Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.45,129.48l-.1-16a20.5,20.5,0,0,0-13.23,5.16,19,19,0,0,0-6.37,16.6,22.13,22.13,0,0,0,.38,2.33.13.13,0,0,0,0,.06h0l19.31-4.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.36,124.55a19,19,0,0,0-15.59-10.91l-.61-.06-.39,0c-.38,0-.77,0-1.16,0h-.11l.11,16,0,3.76L418,137.53h0a18.57,18.57,0,0,0,.43-4.15A20.71,20.71,0,0,0,416.36,124.55Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.36,124.55a19,19,0,0,0-15.59-10.91l-.61-.06-.39,0c-.38,0-.77,0-1.16,0h-.11l.11,16,0,3.76L418,137.53h0a18.57,18.57,0,0,0,.43-4.15A20.71,20.71,0,0,0,416.36,124.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M397.49,135.25l-19.32,4.35a19.8,19.8,0,0,0,38.66-.13l-19.32-4.22",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.67,132.37c0,.14-10,.26-22.3.26s-22.31-.12-22.31-.26,10-.27,22.31-.27S472.67,132.22,472.67,132.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.67,127.28c0,.14-10,.26-22.3.26s-22.31-.12-22.31-.26,10-.26,22.31-.26S472.67,127.14,472.67,127.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.67,122.2c0,.14-10,.26-22.3.26s-22.31-.12-22.31-.26,10-.26,22.31-.26S472.67,122.05,472.67,122.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.67,137.1c0,.14-10,.26-22.3.26s-22.31-.12-22.31-.26,10-.27,22.31-.27S472.67,137,472.67,137.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.86,142.24c0,.15-6.86.26-15.32.26s-15.32-.11-15.32-.26,6.86-.26,15.32-.26S458.86,142.1,458.86,142.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.29,
    y: 179.05,
    width: 4.59,
    height: 51.31,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.16,
    y: 196.47,
    width: 4.59,
    height: 33.88,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.03,
    y: 185.42,
    width: 4.59,
    height: 45.19,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.9,
    y: 181.03,
    width: 4.59,
    height: 49.33,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.76,
    y: 197.51,
    width: 4.59,
    height: 32.84,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.63,
    y: 203.95,
    width: 4.59,
    height: 26.4,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.5,
    y: 184.31,
    width: 4.59,
    height: 46.04,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.37,
    y: 192.61,
    width: 4.59,
    height: 37.74,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.24,
    y: 185.98,
    width: 4.59,
    height: 44.37,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.11,
    y: 200.12,
    width: 4.59,
    height: 30.23,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.98,
    y: 194.37,
    width: 4.59,
    height: 35.98,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.45,233.93c0,.1-21.79.19-48.67.19s-48.67-.09-48.67-.19,21.79-.19,48.67-.19S476.45,233.82,476.45,233.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.84,238a32.39,32.39,0,0,1-6.82,0,30.7,30.7,0,0,1,6.82,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.15,238.17a43.79,43.79,0,0,1-8.15,0,43.79,43.79,0,0,1,8.15,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8,238.17a43.79,43.79,0,0,1-8.15,0,43.79,43.79,0,0,1,8.15,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.44,238.17a43.79,43.79,0,0,1-8.15,0,43.79,43.79,0,0,1,8.15,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.09,238.17a43.79,43.79,0,0,1-8.15,0,43.79,43.79,0,0,1,8.15,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.73,238.17a43.79,43.79,0,0,1-8.15,0,43.79,43.79,0,0,1,8.15,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.38,238.17a43.79,43.79,0,0,1-8.15,0,43.79,43.79,0,0,1,8.15,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,238.17a43.79,43.79,0,0,1-8.15,0,43.79,43.79,0,0,1,8.15,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.67,238.17a43.79,43.79,0,0,1-8.15,0,43.79,43.79,0,0,1,8.15,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.32,238.17a43.79,43.79,0,0,1-8.15,0,43.79,43.79,0,0,1,8.15,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.16,
    y: 196.47,
    width: 4.59,
    height: 33.88,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.9,
    y: 181.03,
    width: 4.59,
    height: 49.33,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.63,
    y: 203.95,
    width: 4.59,
    height: 26.4,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 443.37,
    y: 192.61,
    width: 4.59,
    height: 37.74,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.11,
    y: 200.12,
    width: 4.59,
    height: 30.23,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.4,120.31a4.43,4.43,0,1,1-4.42-4.42A4.42,4.42,0,0,1,259.4,120.31Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.43,116.82c0,.15-14.91.26-33.3.26s-33.3-.11-33.3-.26,14.9-.26,33.3-.26S335.43,116.68,335.43,116.82Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.56,122.17a3.69,3.69,0,0,1-1,.1l-2.81.09c-2.38,0-5.66.07-9.28.07s-6.91,0-9.28-.07l-2.82-.09a3.77,3.77,0,0,1-1-.1,4.35,4.35,0,0,1,1-.1c.67,0,1.63-.06,2.82-.08,2.37,0,5.65-.08,9.28-.08s6.9,0,9.28.08c1.19,0,2.15.05,2.81.08A4.25,4.25,0,0,1,295.56,122.17Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.56,
    y: 103.23,
    width: 139.91,
    height: 159.68,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.48,262.9s0-.26,0-.75,0-1.25,0-2.22c0-2,0-4.85,0-8.62,0-7.54,0-18.57-.06-32.58,0-28-.07-67.89-.11-115.5l.23.23-139.9,0h0l.26-.26c0,58.87,0,113.77,0,159.67l-.22-.22L183,262.8l28.38.06,7.48,0,2.58,0-2.54,0-7.43,0-28.33.06-101.62.11h-.22v-.23c0-45.9,0-100.8,0-159.67V103h.28l139.9,0h.23v.23c-.05,47.67-.09,87.61-.12,115.65,0,14-.05,25-.06,32.52,0,3.75,0,6.63,0,8.58,0,1,0,1.69,0,2.19S221.48,262.9,221.48,262.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.45,184.76c0,.1-1.55-.78-4.5-1.71a29,29,0,0,0-12.9-1,28.36,28.36,0,0,0-8.51,2.74,39.62,39.62,0,0,0-8.37,6c-2.74,2.42-5.47,5.17-8.61,7.71a29.68,29.68,0,0,1-11,5.94,16.36,16.36,0,0,1-6.41.39,21.13,21.13,0,0,1-5.95-1.83,104.8,104.8,0,0,1-10-5.93,30.74,30.74,0,0,0-9.36-4.19,27.67,27.67,0,0,0-8.91-.69,28.6,28.6,0,0,0-12.3,4c-2.64,1.61-3.88,2.82-4,2.74a5,5,0,0,1,.89-.88,22,22,0,0,1,2.86-2.18,28.12,28.12,0,0,1,21.59-3.78,31.75,31.75,0,0,1,9.64,4.22,103.91,103.91,0,0,0,9.9,5.82,16.91,16.91,0,0,0,11.73,1.38A29.17,29.17,0,0,0,166,197.83c3.1-2.49,5.83-5.22,8.62-7.65a40.21,40.21,0,0,1,8.59-6.06,28.44,28.44,0,0,1,21.89-1.42,22.11,22.11,0,0,1,3.3,1.42A6.45,6.45,0,0,1,209.45,184.76Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.07,
    y: 206.21,
    width: 11.89,
    height: 32.17,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.55,
    y: 206.21,
    width: 11.89,
    height: 32.17,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.37,
    y: 187.31,
    width: 11.89,
    height: 51.06,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.68,
    y: 228.25,
    width: 11.89,
    height: 10.83,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.9,
    y: 220.73,
    width: 11.9,
    height: 17.64,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.72,
    y: 216.68,
    width: 11.89,
    height: 21.69,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.45,242.17c0,.26-2.88.48-6.43.48s-6.43-.22-6.43-.48,2.88-.48,6.43-.48S132.45,241.9,132.45,242.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.65,242.17c0,.26-2.88.48-6.43.48s-6.43-.22-6.43-.48,2.88-.48,6.43-.48S117.65,241.9,117.65,242.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.61,242.17c0,.26-3.25.48-7.26.48s-7.27-.22-7.27-.48,3.25-.48,7.27-.48S201.61,241.9,201.61,242.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.68,
    cy: 242.17,
    rx: 7.26,
    ry: 0.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.62,242.17c0,.26-2.88.48-6.43.48s-6.43-.22-6.43-.48,2.88-.48,6.43-.48S165.62,241.9,165.62,242.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.23,242.17c0,.26-2.87.48-6.42.48s-6.43-.22-6.43-.48,2.88-.48,6.43-.48S148.23,241.9,148.23,242.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.4,
    y: 126.51,
    width: 97.21,
    height: 40.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.6,139.26a4.54,4.54,0,1,1-4.54-4.53A4.54,4.54,0,0,1,124.6,139.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.13,
    y: 136.13,
    width: 31.58,
    height: 1.75,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.13,
    y: 140.12,
    width: 61.43,
    height: 1.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.6,153.2a4.54,4.54,0,1,1-4.54-4.53A4.53,4.53,0,0,1,124.6,153.2Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.13,
    y: 150.07,
    width: 16.12,
    height: 1.75,
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.13,
    y: 154.05,
    width: 61.43,
    height: 1.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.36,
    y: 74.56,
    width: 153.64,
    height: 175.35,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661,249.91s0-.29,0-.83,0-1.37,0-2.44c0-2.15,0-5.32,0-9.46,0-8.28,0-20.39-.06-35.77,0-30.75-.07-74.56-.11-126.85l.23.23-153.63,0h0l.27-.26c0,64.65,0,124.94-.05,175.35l-.22-.22,111.45.11,31.15.06,8.21,0,2.84,0s-.94,0-2.79,0l-8.17,0L619,250l-111.59.11h-.22v-.22c0-50.41,0-110.7,0-175.35V74.3h.28l153.63,0h.23v.23c0,52.35-.09,96.21-.12,127,0,15.37,0,27.46-.06,35.73,0,4.11,0,7.27,0,9.41v2.41C661,249.64,661,249.91,661,249.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.66,
    y: 88.58,
    width: 124.46,
    height: 99.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.35,
    y: 170.68,
    width: 4.08,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.6,
    y: 176.97,
    width: 5.22,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 555.78,
    y: 176.97,
    width: 5.22,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.97,
    y: 176.97,
    width: 5.22,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592.15,
    y: 176.97,
    width: 5.22,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.34,
    y: 176.97,
    width: 5.22,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.52,
    y: 176.97,
    width: 5.22,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.35,
    y: 154.95,
    width: 4.08,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.35,
    y: 125.37,
    width: 4.08,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.35,
    y: 110.5,
    width: 4.08,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.56,
    y: 140.16,
    width: 4.08,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.6,171.85a2.5,2.5,0,0,1-.44,0l-1.28,0-5,0-18.17.09-60,.07H534.31v-.26c0-20,.07-37.69.09-50.35,0-6.3.06-11.36.08-14.87,0-1.72,0-3.06,0-4,0-.44,0-.78,0-1a1.35,1.35,0,0,1,0-.35,1.35,1.35,0,0,1,0,.35c0,.26,0,.6,0,1,0,.94,0,2.28,0,4,0,3.51.05,8.57.08,14.87,0,12.66,0,30.31.09,50.35l-.26-.25h14.21l60,.08,18.17.08,5,.05,1.28,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.75,140.75c0,.14-21.54.26-48.11.26s-48.12-.12-48.12-.26,21.54-.26,48.12-.26S634.75,140.61,634.75,140.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.75,126c0,.15-21.54.26-48.11.26s-48.12-.11-48.12-.26,21.54-.26,48.12-.26S634.75,125.81,634.75,126Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.75,111.08c0,.15-21.54.26-48.11.26s-48.12-.11-48.12-.26,21.54-.26,48.12-.26S634.75,110.94,634.75,111.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.75,155.54c0,.15-21.54.26-48.11.26s-48.12-.11-48.12-.26,21.54-.26,48.12-.26S634.75,155.4,634.75,155.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.51,168.67V155.54l8.18-12.7,5.56,4.26,11.39-17.7,6.72,4.73,9.35-16.33,7.6,6.19,11.39-21.66L612,126.54l9.93-12.11,11.69-3.35v57.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.75,106.42s-.07,0-.21,0l-.61,0-2.37,0-9,.07.12-.06-9.6,12.57-.06.08H613l-24.06,0,.21-.12c-3.17,5.27-6.58,11-10.11,16.84l-9.94,16.51-.19.32-.23-.3c-4.74-6.54-9.14-12.59-13-17.93H556L544.05,153l-3.33,5.11-.89,1.33c-.2.3-.32.45-.32.45s.08-.17.27-.48l.83-1.37,3.24-5.17,11.75-18.61.17-.27.18.26L569,152.16l-.42,0,9.92-16.52,10.13-16.83.07-.12h.15l24.06,0-.16.08,9.69-12.49,0-.06h.07l9,.07,2.37,0,.61,0Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.73,138.61a.93.93,0,1,1-.93-.89A.91.91,0,0,1,559.73,138.61Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.48,122.83a.93.93,0,1,1-.92-.88A.91.91,0,0,1,587.48,122.83Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.06,119a.93.93,0,1,1-.93-.89A.91.91,0,0,1,609.06,119Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.51,203.27c0,.15-26.26.26-58.65.26s-58.66-.11-58.66-.26,26.26-.26,58.66-.26S638.51,203.13,638.51,203.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.51,209.61c0,.15-26.26.26-58.65.26s-58.66-.11-58.66-.26,26.26-.26,58.66-.26S638.51,209.47,638.51,209.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.51,216c0,.14-26.26.26-58.65.26s-58.66-.12-58.66-.26,26.26-.26,58.66-.26S638.51,215.81,638.51,216Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.51,222.3c0,.14-26.26.26-58.65.26s-58.66-.12-58.66-.26,26.26-.26,58.66-.26S638.51,222.15,638.51,222.3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.18,219.81c3.21-5.39,4.15-12.57,5-18.79.38-2.93,1.06-7.09-1-8.93s-2.4-5-4.93-6.51a7.78,7.78,0,0,0-8.36.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.28,238.9h0a8.66,8.66,0,0,1-9.32-8.3c-.18-4.72-.34-9.48-.34-9.48s-7.14-.67-7.66-7.74-.28-23.39-.28-23.39h0a24.63,24.63,0,0,1,24.9,1.6l-.44,24.88v13.39C590.09,234.35,587.76,238.56,583.28,238.9Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573,204.75a3.62,3.62,0,0,1,4.83-1.06,4.12,4.12,0,0,1,1.37,5.14,5.43,5.43,0,0,1-3.47,2.62,2.73,2.73,0,0,0-2.13,2.93c.21,1.77,3.16,2.44,4.49,3.91,2.07,2.28,6.62,3.25,9.69,3.61s2.64.38,4.39-2.09a9.41,9.41,0,0,0,1.72-5.74l.33-15.64a22.39,22.39,0,0,0-.36-5.61,7.52,7.52,0,0,0-3-4.64c-1.72-1.13-3.9-1.23-5.85-1.86-2.45-.79-4.53-2.42-6.82-3.59s-5.1-1.87-7.4-.72c-1.65.83-2.76,2.48-4.37,3.39-2.28,1.3-5.39,1-6.5,4.37a5.59,5.59,0,0,0,0,3.59c1.55,4.58,7.21,6.42,11.29,4.44.08.78-.68,2.5.13,4.95.26.78.36,2,1.58,2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.27,209.16c.06,0,.3.37.89.34a1.66,1.66,0,0,0,1.32-1.62,1.77,1.77,0,0,0-1.21-1.76c-.59-.21-1-.1-1-.18s.39-.32,1.12-.17a2.17,2.17,0,0,1,1.11.64,2.08,2.08,0,0,1,.52,1.5,1.94,1.94,0,0,1-1.84,2,1.06,1.06,0,0,1-.79-.39C574.24,209.29,574.24,209.17,574.27,209.16Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.63,187.84s.15-.27.59-.6a4.86,4.86,0,0,1,2.15-.83,6.18,6.18,0,0,1,3.38.51,7.74,7.74,0,0,1,3.12,2.79,15.86,15.86,0,0,1,2.2,7.16,18.88,18.88,0,0,1,.19,3.09,17.28,17.28,0,0,1-.56-3,17,17,0,0,0-2.26-6.92,7.53,7.53,0,0,0-2.89-2.64,5.71,5.71,0,0,0-5.92.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.72,195.08a.69.69,0,0,1-.27,0,2.14,2.14,0,0,1-.7-.32,2.59,2.59,0,0,1-.82-.92,2.34,2.34,0,0,1-.22-1.64,2.69,2.69,0,0,1,1.14-1.65,3.86,3.86,0,0,1,2.24-.44,3.06,3.06,0,0,0,2.13-.54,15,15,0,0,0,1.73-1.86,8.76,8.76,0,0,1,4.41-2.54,9.43,9.43,0,0,1,4.14-.1,8,8,0,0,1,2.61,1,3.19,3.19,0,0,1,.81.62,12.5,12.5,0,0,0-3.48-1.26,9.41,9.41,0,0,0-4,.19,8.5,8.5,0,0,0-4.13,2.43,14.83,14.83,0,0,1-1.81,1.92,2.94,2.94,0,0,1-1.22.55,5.76,5.76,0,0,1-1.23.06,3.47,3.47,0,0,0-2,.32,2.32,2.32,0,0,0-1,1.38,2.27,2.27,0,0,0,.8,2.31A5.88,5.88,0,0,0,561.72,195.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.64,214.75c0-.05.35-.18.93-.57A5.85,5.85,0,0,0,583.5,212a5.35,5.35,0,0,0,.32-4.14,5.29,5.29,0,0,0-1.28-2.13,10.31,10.31,0,0,0-2.21-1.61c-.83-.48-1.67-.93-2.43-1.45a8.07,8.07,0,0,1-2-1.85,8.54,8.54,0,0,1-1.66-4.18,7.81,7.81,0,0,1,.24-3,3.37,3.37,0,0,1,.28-.77c.08-.18.13-.26.14-.25a10.68,10.68,0,0,0-.29,4,8.45,8.45,0,0,0,1.67,3.94,8.1,8.1,0,0,0,1.86,1.72c.74.49,1.57.93,2.41,1.42a10.39,10.39,0,0,1,2.32,1.71,5.75,5.75,0,0,1,1.37,2.33,5.67,5.67,0,0,1-.46,4.47,5.6,5.6,0,0,1-2.14,2.14A2.75,2.75,0,0,1,580.64,214.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.9,204.37a3.07,3.07,0,0,1-.91.21,13.92,13.92,0,0,1-2.55.07,15.67,15.67,0,0,1-7.88-2.71,12.5,12.5,0,0,1-5.18-6.51,5.42,5.42,0,0,1-.1-2.56,2,2,0,0,1,.35-.87,6.32,6.32,0,0,0,.11,3.33,12.78,12.78,0,0,0,5.11,6.18,16.59,16.59,0,0,0,7.62,2.77C591.57,204.51,592.89,204.27,592.9,204.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594,199.53a12.51,12.51,0,0,1,9.75-4.42c3.68.21,7.27,2.76,8.17,6.33.68,2.7-.15,5.51-.49,8.26s0,6,2.23,7.61c1.36,1,3.11,1.16,4.74,1.56s3.36,1.21,3.92,2.79c.64,1.81-.67,3.86-2.43,4.63a9,9,0,0,1-5.66.08,4.73,4.73,0,0,1-2.1,5.66,6.25,6.25,0,0,1-6.28-.26,9.38,9.38,0,0,1-3.83-5.2c-1.21,2.13-4.39,2.58-6.43,1.22a6.72,6.72,0,0,1-2.6-6.46,12.5,12.5,0,0,1,3.26-6.46,16.21,16.21,0,0,0,2.27-2.9,3.67,3.67,0,0,0,.14-3.53,2.12,2.12,0,0,0-3.14-.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.27,207a2.44,2.44,0,0,1-2.12,0,5.09,5.09,0,0,1-3.08-4,5.24,5.24,0,0,1,.33-2.87,5.43,5.43,0,0,1,1.36-1.92,3.43,3.43,0,0,1,1.86-1,16.13,16.13,0,0,0-1.6,1.3,5.24,5.24,0,0,0-1.44,4.45,5,5,0,0,0,2.71,3.76A5.16,5.16,0,0,0,598.27,207Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.39,221a3.33,3.33,0,0,1-1.62-.16,8.74,8.74,0,0,1-5.72-5.06,3.29,3.29,0,0,1-.36-1.58,11.55,11.55,0,0,1,.69,1.43,10.05,10.05,0,0,0,2.29,3,10.26,10.26,0,0,0,3.21,1.91A10.14,10.14,0,0,1,573.39,221Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.61,226.79s-.13,0-.35,0a3.33,3.33,0,0,1-.92-.41,5,5,0,0,1-2-3.05,6.44,6.44,0,0,1-.09-2.57,10.15,10.15,0,0,1,.94-2.78c.89-1.87,2.29-3.64,3.33-5.69a10,10,0,0,0,1-3.15,6.09,6.09,0,0,0-3.93-6.56,6.48,6.48,0,0,0-3.5-.21c-.83.17-1.25.4-1.27.36s.09-.08.29-.2a5.33,5.33,0,0,1,.93-.36,6.29,6.29,0,0,1,7.59,3.79,6.61,6.61,0,0,1,.4,3.24,10.62,10.62,0,0,1-1.09,3.32c-1.08,2.12-2.49,3.87-3.37,5.67a7.56,7.56,0,0,0-.92,5.06,5,5,0,0,0,1.76,3A7.75,7.75,0,0,0,600.61,226.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.27,232a2.12,2.12,0,0,1-.44,0,5,5,0,0,1-1.26-.22,7.13,7.13,0,0,1-3.69-2.87,10.92,10.92,0,0,1-1.58-6.74,66.92,66.92,0,0,1,1.36-8.37,19.89,19.89,0,0,0,.3-4.31,11.21,11.21,0,0,0-.91-3.86,7,7,0,0,0-5-4.14,10.21,10.21,0,0,0-4.55,0c-1.07.24-1.63.48-1.65.43s.13-.09.39-.21a10.52,10.52,0,0,1,1.21-.42,9.91,9.91,0,0,1,4.68-.17,7.43,7.43,0,0,1,3,1.34,7.7,7.7,0,0,1,2.33,3,11.3,11.3,0,0,1,1,4,19,19,0,0,1-.29,4.42,77.13,77.13,0,0,0-1.4,8.31,10.73,10.73,0,0,0,1.42,6.51,7.06,7.06,0,0,0,3.44,2.88A11,11,0,0,0,611.27,232Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "613.4 264.17 598.35 275.91 604.66 286.29 622.8 272.93 613.4 264.17",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.12,224.7s.08-1.26-3.21-1.44a33.63,33.63,0,0,0-3.65-.12,8.34,8.34,0,0,1-1.57-3,9.21,9.21,0,0,1,.7-3.1l3.33-.3-.9-2.26-2.35.16-6.61.8L556.23,227l-18.06,33.7a8.71,8.71,0,0,0,3.45,12.67h0c4.67,2.26,10.92-2.53,12.65-7.42l10-37.49,3.52-2.74,5-.92",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532,449,556.55,307.6h0c.06-.21.11-.41.16-.61v0h0c4.19-16.59,10.64-21.9,10.64-21.9l37.61,2.36c3.2,5.75,3.61,19.54,3.61,19.54.44,1.69-7.95,138.72-7.95,138.72L588,445.32l-6.82-129.64L544.57,449.55Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.67,450.28l.05-1.27,12.94.37-.11,4.21-.8,0c-3.56.09-18.11.21-20.47-.52C520.66,452.28,531.67,450.28,531.67,450.28Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539.88,453.37a4.18,4.18,0,0,1,1.72-2.51,4.61,4.61,0,0,1,3-.79l-.1,3.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526.28,451.44s-3.86.92-3.4,1.52,15.17,1,21.67.63v-.27L527.38,453S527,451.49,526.28,451.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M544.74,453.32l-.22,0-.64,0-2.34,0c-2,0-4.72,0-7.74-.08s-5.75-.2-7.73-.32l-2.34-.15-.63,0c-.15,0-.22,0-.22,0h.22l.64,0,2.34.1c2,.09,4.71.2,7.73.28s5.75.1,7.73.12h3.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.37,453.19a3,3,0,0,0-1.18-1.9,1.62,1.62,0,0,1,.91.78A1.5,1.5,0,0,1,527.37,453.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.23,451.5s-.21-.19-.39-.47-.3-.52-.26-.54.21.19.39.47S531.27,451.48,531.23,451.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.29,451s-.23-.11-.45-.3-.37-.37-.34-.4a1.22,1.22,0,0,1,.45.3C532.17,450.81,532.32,451,532.29,451Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533,449.9a1.64,1.64,0,0,1-.67.07,1.59,1.59,0,0,1-.67-.09,1.54,1.54,0,0,1,.67-.06A1.74,1.74,0,0,1,533,449.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.23,449.11a1.3,1.3,0,0,1-.75.19,1.38,1.38,0,0,1-.78-.12,4.64,4.64,0,0,1,.77,0A4.19,4.19,0,0,1,533.23,449.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.82,450.45a2.88,2.88,0,0,1-.82,0,6,6,0,0,1-.88-.2,3,3,0,0,1-.5-.21.43.43,0,0,1-.2-.25.29.29,0,0,1,.14-.3,1.58,1.58,0,0,1,1.86.46,1.31,1.31,0,0,1,.26.52c0,.14,0,.21,0,.21a2.09,2.09,0,0,0-.35-.67,1.56,1.56,0,0,0-.7-.44,1.36,1.36,0,0,0-1,0c-.13.08-.08.23.06.31a2.37,2.37,0,0,0,.46.2,6.1,6.1,0,0,0,.85.23C530.51,450.41,530.82,450.42,530.82,450.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.61,450.48a.72.72,0,0,1-.08-.54,1.22,1.22,0,0,1,.24-.56.87.87,0,0,1,.7-.37.31.31,0,0,1,.25.36.82.82,0,0,1-.15.34,2.72,2.72,0,0,1-.41.46,1.3,1.3,0,0,1-.48.3s.17-.14.4-.37a2.23,2.23,0,0,0,.36-.46c.12-.16.21-.45,0-.49a.77.77,0,0,0-.55.32,1.09,1.09,0,0,0-.25.49A2.25,2.25,0,0,0,530.61,450.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.58,450s-.37,0-1,0a4.55,4.55,0,0,0-2.1.74,3.94,3.94,0,0,0-1.35,1.68c-.21.5-.24.85-.27.84a.62.62,0,0,1,0-.24,2.93,2.93,0,0,1,.16-.64,3.69,3.69,0,0,1,1.36-1.75,4.18,4.18,0,0,1,2.19-.73,3.35,3.35,0,0,1,.7,0A.66.66,0,0,1,544.58,450Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.3,452.16a7.56,7.56,0,0,1-1.89.13,8.46,8.46,0,0,1-1.88-.19c0-.05.85,0,1.88,0S538.29,452.12,538.3,452.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.82,452.23s-.07.16-.16.34-.15.33-.19.33-.06-.19,0-.4S540.79,452.2,540.82,452.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.81,451.15s-.06.15-.2.27-.27.2-.3.17.06-.15.19-.27S541.78,451.12,541.81,451.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.18,450.68s-.18,0-.37.09-.33.15-.36.12.08-.19.31-.26S543.2,450.65,543.18,450.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.16,450.47s-.06.1-.17.13-.21,0-.22,0,.06-.1.17-.13S544.14,450.43,544.16,450.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.87,228.68a24.79,24.79,0,0,1,10,3.92c11.89,7.71,31.78,24,30.13,31.57C633.56,270.59,618,278.4,618,278.4L608,266.28l6.17-3.53L599,252.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.65,253.23l-.49,1.8-1.75,8.36L599,275.64c9,11.62,9.16,21.4,9.16,21.4l-45.57,5.32c0-9,3.29-20.34,3.29-20.34,2.63-4.47,2.51-17.85,2-18.34-2.84-2.82-3.53-4.89-1.26-8.5,0,0-14.13,14.84-15.58,16.17-5,4.58-9.8,3.3-12,1.31-6.24-5.57.16-12.75.16-12.75L563,232.64a11.87,11.87,0,0,1,6.18-3.77,51.34,51.34,0,0,1,5.1-.9l15.89.13a26.92,26.92,0,0,1,4.73.58,11.35,11.35,0,0,1,6.94,8.6C603.23,244.11,601.65,253.23,601.65,253.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.15,242.3a6.08,6.08,0,0,1,.1,1.32c0,.85,0,2.09-.09,3.61A94.6,94.6,0,0,1,600.59,259c-.29,1.55-.61,3.05-.94,4.44v-.05c-.14,3.54-.28,6.6-.4,8.78-.07,1-.12,1.86-.16,2.54a3.83,3.83,0,0,1-.12.92,3.54,3.54,0,0,1-.05-.92c0-.69,0-1.54,0-2.55,0-2.18.11-5.25.22-8.79v-.05c.31-1.37.62-2.87.91-4.42.87-4.54,1.45-8.69,1.72-11.71.13-1.51.2-2.73.25-3.58A7,7,0,0,1,602.15,242.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.3,254.55a190.66,190.66,0,0,1,16.35,11.31,92.34,92.34,0,0,1-8.32-5.44A95.44,95.44,0,0,1,602.3,254.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.84,236.69s.1.05.24.18a4.75,4.75,0,0,1,.56.62,6.91,6.91,0,0,1,1.24,2.82,9.32,9.32,0,0,1-.26,4.57,18.67,18.67,0,0,1-2.56,5,17.65,17.65,0,0,1-1.88,2.21c-.66.67-1.37,1.22-2,1.79-1.26,1.13-2.34,2.2-3.24,3.12s-1.61,1.67-2.1,2.19-.77.82-.8.79a4.92,4.92,0,0,1,.65-.92c.44-.56,1.11-1.36,2-2.32s1.93-2,3.19-3.21c.63-.59,1.32-1.15,2-1.8a17.59,17.59,0,0,0,1.82-2.16,19.15,19.15,0,0,0,2.52-4.8,9.34,9.34,0,0,0,.36-4.36A8.17,8.17,0,0,0,572.84,236.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "567.54 276.98 568.07 270.86 599.15 270.86 598.98 275.64 567.54 276.98",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541,258.71a19.84,19.84,0,0,0-1.73,1.8,8.27,8.27,0,0,0,.44,10.85,23.92,23.92,0,0,0,1.87,1.66s-.25,0-.64-.27a7.08,7.08,0,0,1-1.49-1.13,8.21,8.21,0,0,1-.46-11.35,6.85,6.85,0,0,1,1.39-1.25C540.78,258.78,541,258.68,541,258.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "600.58 445.67 604.11 453.87 588.33 453.68 588 445.32 600.58 445.67",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.22,452.26a14.36,14.36,0,0,0,2.2.11c1.37,0,3.26,0,5.34,0l5.32-.11a15.4,15.4,0,0,0,2.21-.12,15.66,15.66,0,0,0-2.21-.1c-1.37,0-3.25,0-5.33,0l-5.33.1A18.74,18.74,0,0,0,588.22,452.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.79,445.49a10.85,10.85,0,0,0-.06,3.32,11.14,11.14,0,0,0,.43,3.3,10.85,10.85,0,0,0,.06-3.32A11.14,11.14,0,0,0,594.79,445.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "604.08 454.04 588.32 453.51 588.22 452.01 603.29 452.14 604.09 453.86",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.13,289.14c11.87,37.45-3.43,82.91.24,126.55.36,4.29,2.1,9.41-1.91,11.85a6.54,6.54,0,0,1-3.62.89c-3.2-.11-5.88-1.77-8.74-2.91a26,26,0,0,0-17.2-.67c-3.78,1.18-7.54,3.27-11.46,2.68-5.21-.79-8.58-5.94-13.37-8.12-4.49-2-9.67-1.28-14.6-1.4h-.15a11.06,11.06,0,0,1-10.22-14c7.17-26.24,30.92-111.46,41.44-127L599,275.64C601.88,279.14,605.6,284.37,607.13,289.14Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.12,306.77a14,14,0,0,1-1.71,2.15,50.82,50.82,0,0,1-4.64,4.75,31.05,31.05,0,0,1-5.48,3.76,12.39,12.39,0,0,1-2.5,1.16c-.11-.18,3.74-2,7.63-5.32,1.94-1.68,3.53-3.39,4.72-4.6A14.16,14.16,0,0,1,596.12,306.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M582.24,320.9A133.89,133.89,0,0,0,577,401.06c.56,2.29,1.14,4.89-.17,6.86-1.68,2.54-5.77,2.37-8.08.37s-3.23-5.13-3.81-8.13c-4.32-22.34,3.5-44.8,11.94-65.93"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344.33,
    y: 333.52,
    width: 59.59,
    height: 2.9,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.09 336.42 323.92 294.54 370.44 294.54 380.56 336.42 335.09 336.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.77 333.25 336.21 333.25 326.54 296.47 368.31 296.47 377.77 333.25",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.23,299.12H369l-.71-2.65H326.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.74,297.8a.46.46,0,1,0,.46-.46A.46.46,0,0,0,331.74,297.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.17,297.8a.46.46,0,1,0,.46-.46A.46.46,0,0,0,330.17,297.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.6,297.8a.46.46,0,0,0,.46.45.46.46,0,0,0,0-.91A.46.46,0,0,0,328.6,297.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.63,315.23l4.58,5.24A6.47,6.47,0,0,0,366,315.2c0-3.66-3.36-6.66-7.41-6.64s-7.38,3-7.36,6.7Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.05,316.07a10.24,10.24,0,0,1,1.31,1.31c.82.88,2,2.16,3.38,3.72l.16.18-.2.14a7.87,7.87,0,0,1-7.71.76,7.6,7.6,0,0,1-3.18-2.55,6.51,6.51,0,0,1-1.17-3.44V316h.23c2.19,0,4,0,5.26,0a11.94,11.94,0,0,1,1.93.09,13.64,13.64,0,0,1-2,.16c-1.26.06-3,.12-5.18.18l.22-.24a6.28,6.28,0,0,0,1.14,3.17,7.09,7.09,0,0,0,3,2.36,7.58,7.58,0,0,0,7.25-.63l0,.32c-1.33-1.55-2.42-2.86-3.18-3.79A13.28,13.28,0,0,1,358.05,316.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.06,311.28a.43.43,0,0,0,.42.42.42.42,0,0,0,.41-.42.41.41,0,0,0-.41-.41A.41.41,0,0,0,355.06,311.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.83,308.29a23.24,23.24,0,0,1,4.95-.28h.76l.08.07a19.79,19.79,0,0,1,2.86,3.2,20.17,20.17,0,0,1-3.23-2.83l.19.07h-.66A24.19,24.19,0,0,1,346.83,308.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.48,313.52a12.94,12.94,0,0,1-.48-1.93c-.28-1.27-.67-3.12-1.13-5.39l-.05-.25h.26l10.34-.09c-.06,0,.49.41.26.22h0v.11l0,.12,0,.25.09.49c.06.33.13.65.19,1,.12.64.23,1.27.35,1.89.23,1.23.44,2.41.65,3.53l.05.28h-.28c-3.11,0-5.72-.05-7.54-.08l-2.09-.06a2.93,2.93,0,0,1-.71-.06,4.5,4.5,0,0,1,.8-.06l2.14-.07c1.83-.05,4.38-.11,7.4-.14l-.23.28L346.9,310c-.12-.61-.24-1.24-.36-1.88-.06-.32-.13-.65-.19-1l-.09-.49-.05-.25,0-.12v-.1h0c-.23-.19.31.26.25.22H336.08l.21-.25c.39,2.19.69,4,.9,5.32S337.5,313.49,337.48,313.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.45,319.61a.42.42,0,0,0,.83,0,.42.42,0,0,0-.42-.42A.41.41,0,0,0,354.45,319.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.35,319.64a13.48,13.48,0,0,1,3.76-.28,13.25,13.25,0,0,1,3.75.25,13.67,13.67,0,0,1-3.75.27A14,14,0,0,1,347.35,319.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.51,322.9a9.2,9.2,0,0,1-.45-1.38c-.27-.92-.66-2.28-1.13-4l-.06-.24h.25c2.82-.05,6.57-.09,10.67-.1l.25.19h0v.08l0,.09,0,.18.09.36.18.7c.12.47.24.93.35,1.38.23.9.45,1.78.66,2.62l.08.3h-.31c-3.16,0-5.86,0-7.74-.08l-2.18-.06a3.46,3.46,0,0,1-.75-.06,5.82,5.82,0,0,1,.84-.07l2.23-.07c1.89-.06,4.52-.11,7.6-.14l-.24.3c-.22-.84-.45-1.71-.68-2.61l-.36-1.38-.18-.71-.09-.35-.05-.18,0-.09v-.07h0c-.06,0,.48.37.25.2-4.1,0-7.85,0-10.66,0l.18-.25c.4,1.64.7,3,.91,3.93A9.94,9.94,0,0,1,337.51,322.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.3,308.41a12.56,12.56,0,0,1,3.53-.27,11.8,11.8,0,0,1,3.54.25,12.61,12.61,0,0,1-3.54.27A11.76,11.76,0,0,1,338.3,308.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.38,309.57a12.81,12.81,0,0,1,3.56-.27,12.57,12.57,0,0,1,3.56.24,24,24,0,0,1-7.12,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.59,310.69a11.34,11.34,0,0,1,3.44-.28,11.93,11.93,0,0,1,3.43.25,11.24,11.24,0,0,1-3.43.28A12,12,0,0,1,338.59,310.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.51,319.54a11.37,11.37,0,0,1,3.37-.27,10.74,10.74,0,0,1,3.37.25,11.48,11.48,0,0,1-3.37.27A10.74,10.74,0,0,1,338.51,319.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.92,320.82a16.08,16.08,0,0,1,5.76,0,16.08,16.08,0,0,1-5.76,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.76 336.29 273.76 341.78 277.36 341.78 277.36 452.99 284.74 452.99 284.74 341.78 323.91 341.78 323.91 452.99 331.29 452.99 331.29 341.78 501.22 341.78 501.22 452.96 508.61 452.96 508.61 341.78 511.8 341.78 511.8 336.29 273.76 336.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.8,377.72a55,55,0,0,0,9.6,0,57.7,57.7,0,0,0-9.6,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 363.89,
    cy: 378.73,
    rx: 0.26,
    ry: 0.13,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.92,279.87l-27.56-28-.6-3c-.11-.55-.23-1.17-.34-1.88a7.52,7.52,0,0,1,.05-2.46,11,11,0,0,1,.85-2.94c.46-.81-.28-1.79-1.05-1.45s-2.1,2.53-2.39,5.56-2.87-1-3.83-2.44-4.16-5.77-4.83-5.82c-1-.08-1.22,1-.23,2.4s3.7,5.9,2.94,6.37h0a3.6,3.6,0,0,0-3.81,1.89c-.7,1.33-1.47,3.23-.84,4.1a49.71,49.71,0,0,0,4.4,4.66l.92.79s23.85,34.56,29.05,35.69c3.23.69,53.21,4.84,53.21,4.84l3.77-13.77Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,251.58l2.55,2.45a3.15,3.15,0,0,0,1,.71,1.06,1.06,0,0,0,1.12-.18,1.08,1.08,0,0,0,.15-1,3,3,0,0,0-.59-.9l-2.48-3",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.75,249.65c.06-.05.53.42,1.26,1.23.41.46.83.93,1.26,1.43a4.61,4.61,0,0,1,.71.95,1.36,1.36,0,0,1-.07,1.41,1.25,1.25,0,0,1-1.4.32,2.83,2.83,0,0,1-1-.7l-1.33-1.36c-.75-.78-1.19-1.29-1.14-1.35a6.06,6.06,0,0,1,1.39,1.09l1.41,1.27a2.41,2.41,0,0,0,.84.57.77.77,0,0,0,.82-.16.87.87,0,0,0,0-.87,4.9,4.9,0,0,0-.61-.87c-.41-.51-.8-1-1.18-1.5A5.8,5.8,0,0,1,370.75,249.65Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.85,249.8l2.55,2.45a3,3,0,0,0,1,.7,1,1,0,0,0,1.12-.18,1.06,1.06,0,0,0,.15-1,3.16,3.16,0,0,0-.59-.91l-2.48-3",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.56,247.86c.06,0,.53.43,1.26,1.24l1.26,1.42a4.61,4.61,0,0,1,.71.95,1.38,1.38,0,0,1-.07,1.42,1.25,1.25,0,0,1-1.4.32,2.83,2.83,0,0,1-1-.7L372,251.15a6.18,6.18,0,0,1-1.14-1.35,6.16,6.16,0,0,1,1.39,1.08l1.41,1.28a2.41,2.41,0,0,0,.84.57.77.77,0,0,0,.82-.16.89.89,0,0,0,0-.88,4.44,4.44,0,0,0-.62-.86l-1.17-1.5A5.55,5.55,0,0,1,372.56,247.86Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.84,248.34l2.55,2.45a2.77,2.77,0,0,0,1,.7.91.91,0,0,0,1.26-1.2,3,3,0,0,0-.59-.91c-.82-1-1.65-2-2.47-3",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.55,246.4a6.52,6.52,0,0,1,1.26,1.23l1.26,1.43a4.59,4.59,0,0,1,.7.95,1.33,1.33,0,0,1-.07,1.42,1.23,1.23,0,0,1-1.39.32,2.83,2.83,0,0,1-1-.7L374,249.69a5.92,5.92,0,0,1-1.13-1.35,6,6,0,0,1,1.39,1.08l1.41,1.28a2.47,2.47,0,0,0,.83.57.76.76,0,0,0,.82-.16.84.84,0,0,0,0-.88,4.84,4.84,0,0,0-.61-.86l-1.17-1.5A5.55,5.55,0,0,1,374.55,246.4Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.87,252.58c0-.09.63-.21,1.55.07l-.29.25a4.36,4.36,0,0,1-.07-1.75,4.45,4.45,0,0,1,1-2.13c.39-.46.72-.64.76-.59a9.05,9.05,0,0,0-1.2,2.8,5.27,5.27,0,0,0,0,1.58l.05.4-.34-.15C377.47,252.72,376.86,252.68,376.87,252.58Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,237.88l.12,38.37-15,.71-.6-9.19s-7.22,1.09-8.73-4.34c-1-3.47-.72-30.27-.72-30.27Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.42,236.94c1.11,2.3,6.39,6.49,6.39,6.49l2.39,6.39c2.07-1.62,4.85-1.53,5.38,2.11.38,2.64-2.89,3.17-2.89,3.17,1.9,3.24,3.19,5.86,6,8.94,3,3.34,4.68,3.67,7.94,3.73h3.59s7.34-6.14,5.89-22.3S437.09,234,433.62,230C428,223.41,414.72,229.29,418.42,236.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.25,259a5.11,5.11,0,0,1-1.77-.08,9.2,9.2,0,0,1-4.29-2.2,23.38,23.38,0,0,1-4.33-5.73c-1.4-2.29-2.93-4.95-5.5-6.73s-5.66-2.09-8.29-2.63a15.7,15.7,0,0,1-6.69-2.55,7.17,7.17,0,0,1-2.68-4,4,4,0,0,1-.07-1.77,5.52,5.52,0,0,0,.15,1.75,7.16,7.16,0,0,0,2.69,3.88,15.73,15.73,0,0,0,6.64,2.47c2.62.53,5.7.87,8.37,2.65s4.15,4.51,5.54,6.8a23.72,23.72,0,0,0,4.27,5.72,9.33,9.33,0,0,0,4.2,2.23,7.22,7.22,0,0,0,1.3.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.1,245.84l-.77-.24a12.93,12.93,0,0,0-2.26-.5,5,5,0,0,0-3.46.78,2.84,2.84,0,0,0-1.21,1.82,2.54,2.54,0,0,0,.7,2.29,2,2,0,0,0,1.21.48,2.46,2.46,0,0,0,1.33-.37,4.07,4.07,0,0,0,1.81-2.31,5.71,5.71,0,0,0-4.83-7.5,10.12,10.12,0,0,0-3.71.48,26.38,26.38,0,0,1-3.85.93,15.48,15.48,0,0,1-4.08,0,13.56,13.56,0,0,1-3.94-1.09,4.74,4.74,0,0,1-2.69-2.84,3.73,3.73,0,0,1,.91-3.63,3.2,3.2,0,0,1,3.52-.51,2.66,2.66,0,0,1,1.3,1.22,3,3,0,0,1,.28,1.72,3.93,3.93,0,0,1-1.75,2.74,5.65,5.65,0,0,1-3,.83,8.78,8.78,0,0,1-2.8-.43,10.12,10.12,0,0,1-4.12-2.54,10.43,10.43,0,0,1-2.1-3,10.93,10.93,0,0,1-.75-2.2c-.09-.52-.12-.8-.12-.8s.06.27.16.79a11.54,11.54,0,0,0,.78,2.17,10.26,10.26,0,0,0,2.11,3,9.87,9.87,0,0,0,4.08,2.48,8.54,8.54,0,0,0,2.76.42,5.51,5.51,0,0,0,2.86-.81,3.73,3.73,0,0,0,1.66-2.62,2.57,2.57,0,0,0-1.47-2.75,3,3,0,0,0-3.3.49,3.52,3.52,0,0,0-.86,3.42,4.58,4.58,0,0,0,2.59,2.71A13.08,13.08,0,0,0,434,241.5a15.1,15.1,0,0,0,4,0,25.6,25.6,0,0,0,3.82-.91,10.11,10.11,0,0,1,3.8-.49,5.91,5.91,0,0,1,5,7.76,4.27,4.27,0,0,1-1.9,2.39,2.62,2.62,0,0,1-1.41.38,2.07,2.07,0,0,1-1.31-.52,2.7,2.7,0,0,1-.73-2.42,3,3,0,0,1,1.27-1.9,5.16,5.16,0,0,1,3.54-.76,11.18,11.18,0,0,1,2.26.54C452.84,245.73,453.1,245.84,453.1,245.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.08,443.62l-4.88-6.27,11.69-9.23,7.25,9.1-.69.62c-3.08,2.72-15.88,13.65-18.55,14.7C425.92,453.71,434.08,443.62,434.08,443.62Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.23,448.72s-2.69,3.76-1.8,4,14.23-10.32,19.71-15.49l-.23-.25-15.46,12.44S430.93,448.21,430.23,448.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M448.09,436.82a1.15,1.15,0,0,1-.18.18l-.55.49-2.05,1.77c-1.75,1.48-4.18,3.5-6.92,5.67s-5.26,4.08-7.1,5.43l-2.2,1.6-.6.42-.22.13.2-.16.58-.45,2.16-1.64c1.82-1.38,4.33-3.3,7.07-5.47s5.18-4.17,6.94-5.63l2.09-1.72.57-.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.6,449.59a6.11,6.11,0,0,0-1.2-.7,5.83,5.83,0,0,0-1.36-.24,2,2,0,0,1,1.42.07A2,2,0,0,1,432.6,449.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.67,445.11c0,.05-.34,0-.73-.15s-.68-.28-.66-.33.34,0,.72.16A1.71,1.71,0,0,1,434.67,445.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.22,443.86c0,.05-.29.08-.63.06s-.62-.08-.62-.13.28-.08.63-.05A1.36,1.36,0,0,1,435.22,443.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.94,442.29s-.21.29-.55.56-.63.46-.66.42.22-.29.55-.56S434.91,442.25,434.94,442.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.53,441.35a2.22,2.22,0,0,1-1.3,1.2c0-.05.3-.27.66-.6S434.49,441.32,434.53,441.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.46,444.41a2.59,2.59,0,0,1-.75.59,5.93,5.93,0,0,1-.94.45,2.57,2.57,0,0,1-.61.18.58.58,0,0,1-.37-.09.37.37,0,0,1-.12-.39,1.75,1.75,0,0,1,2-.94,1.66,1.66,0,0,1,.64.3c.13.11.19.18.18.19a2.52,2.52,0,0,0-.85-.37,1.68,1.68,0,0,0-1,.09,1.5,1.5,0,0,0-.85.77c0,.18.11.29.31.26a3.87,3.87,0,0,0,.56-.15,8.74,8.74,0,0,0,.94-.41C433.16,444.61,433.44,444.38,433.46,444.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.3,444.6s-.27-.09-.5-.45a1.61,1.61,0,0,1-.23-.72,1,1,0,0,1,.32-.87.38.38,0,0,1,.51.16,1.08,1.08,0,0,1,.14.44,3,3,0,0,1,0,.73,1.39,1.39,0,0,1-.19.65s0-.26.06-.66a2.9,2.9,0,0,0,0-.7c0-.24-.18-.58-.39-.46a.84.84,0,0,0-.24.71,1.55,1.55,0,0,0,.17.65A3.58,3.58,0,0,0,433.3,444.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.32,433.81s-.36.23-.83.71a4.7,4.7,0,0,0-1.14,4.86c.22.64.47,1,.44,1s-.08-.07-.19-.23a4.81,4.81,0,0,1-.37-.73,4.7,4.7,0,0,1-.19-2.68,4.52,4.52,0,0,1,1.36-2.32,3.91,3.91,0,0,1,.65-.49A.89.89,0,0,1,445.32,433.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.27,429.9a27.38,27.38,0,0,1,2,2.32c1.06,1.32,1.89,2.41,1.86,2.44a25.4,25.4,0,0,1-2-2.32A23.13,23.13,0,0,1,440.27,429.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.45,440.5a8,8,0,0,1-1.57,1.52,8.53,8.53,0,0,1-1.81,1.21s.77-.6,1.7-1.36S441.42,440.46,441.45,440.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.74,438.68c.05,0,.07.21.13.45s.14.43.1.46-.21-.14-.28-.42S443.7,438.67,443.74,438.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.76,436.93c.05,0,.07.18,0,.4s-.08.39-.13.39-.07-.19-.05-.41S443.71,436.92,443.76,436.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.6,435.46s-.13.17-.25.36-.18.39-.23.38-.08-.24.07-.48S444.59,435.41,444.6,435.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.3,434.53s0,.14,0,.25-.16.19-.2.17,0-.14,0-.26S445.26,434.51,445.3,434.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "445.06 433.51 433.23 442.55 432.14 441.12 444.57 432.7 445.06 433.51"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M380.32,449.92l0-7.95,14.9-.06.09,11.64-.93.06c-4.11.25-20.91.95-23.66.13C367.67,452.82,380.32,449.92,380.32,449.92Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.14,451.56s-4.44,1.29-3.88,2,17.57.66,25.07,0l0-.33-19.84.25S375,451.59,374.14,451.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395.54,453.21l-.26,0-.74,0-2.7.13c-2.29.09-5.45.18-8.94.2s-6.66,0-8.95-.11l-2.7-.1-.74,0-.26,0h1l2.71,0c2.28,0,5.45.07,8.94.06s6.65-.09,8.93-.15l2.71-.07h1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.47,453.7a6.22,6.22,0,0,0-.52-1.29,5.76,5.76,0,0,0-.92-1,2,2,0,0,1,1.08.94A2,2,0,0,1,375.47,453.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.85,451.45s-.25-.23-.47-.57-.36-.64-.32-.66.25.22.47.57S379.89,451.43,379.85,451.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.06,450.81s-.27-.12-.53-.35-.44-.44-.41-.48.27.12.53.35S381.09,450.77,381.06,450.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.81,449.4a1.63,1.63,0,0,1-.77.1,1.68,1.68,0,0,1-.78-.08,1.79,1.79,0,0,1,.77-.1A1.86,1.86,0,0,1,381.81,449.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.07,448.41a1.57,1.57,0,0,1-.87.25,1.5,1.5,0,0,1-.89-.11,4.64,4.64,0,0,1,.88-.07A5.08,5.08,0,0,1,382.07,448.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.34,450.16a2.88,2.88,0,0,1-1,0,5.24,5.24,0,0,1-1-.22,2.68,2.68,0,0,1-.58-.23.56.56,0,0,1-.24-.3.37.37,0,0,1,.15-.38,1.75,1.75,0,0,1,2.17.5,1.67,1.67,0,0,1,.31.64.57.57,0,0,1,0,.26,2.68,2.68,0,0,0-.44-.82,1.77,1.77,0,0,0-.82-.53,1.46,1.46,0,0,0-1.14.09c-.15.11-.09.29.08.39a2.35,2.35,0,0,0,.54.22,6,6,0,0,0,1,.26C379,450.13,379.34,450.13,379.34,450.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.09,450.2a1,1,0,0,1-.11-.66,1.55,1.55,0,0,1,.26-.7,1,1,0,0,1,.79-.49.37.37,0,0,1,.3.44,1.1,1.1,0,0,1-.16.43,2.85,2.85,0,0,1-.45.58c-.3.29-.53.41-.55.39s.19-.17.46-.48a3.51,3.51,0,0,0,.4-.57c.13-.21.21-.57,0-.61s-.48.21-.62.4a1.54,1.54,0,0,0-.27.63A6.07,6.07,0,0,0,379.09,450.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.21,449.13s-.42,0-1.1,0a4.88,4.88,0,0,0-2.39,1,4.73,4.73,0,0,0-1.49,2.13,10.3,10.3,0,0,0-.28,1.07.78.78,0,0,1,0-.3,3.53,3.53,0,0,1,.15-.81,4.75,4.75,0,0,1,1.5-2.23,4.57,4.57,0,0,1,2.5-1,3.45,3.45,0,0,1,.82,0A.72.72,0,0,1,395.21,449.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.64,442.94a25.29,25.29,0,0,1,.15,3.06,28.12,28.12,0,0,1,0,3.06,24.23,24.23,0,0,1-.14-3.06A26.81,26.81,0,0,1,393.64,442.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,452a8.61,8.61,0,0,1-2.17.22,8.94,8.94,0,0,1-2.18-.16c0-.05,1,0,2.18,0S388,452,388,452Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,452s-.07.21-.17.43-.16.42-.21.42-.07-.24,0-.49S390.93,452,391,452Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.06,450.62s-.06.19-.21.34-.31.26-.35.23.06-.2.22-.35S392,450.58,392.06,450.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.63,450s-.21,0-.43.13-.37.2-.41.16.08-.24.36-.33S393.65,449.94,393.63,450Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.75,449.68c0,.05-.07.13-.19.18s-.24.05-.26,0,.07-.12.19-.17S394.73,449.64,394.75,449.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "395.33 448.53 380.31 448.55 380.32 446.75 395.27 446.66 395.33 448.53"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M417.09,312.64l-6,18c-1.61,4.85-5.85,5.68-11,5.68H367v-7.44l30.32-4.33,7.22-18.46Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.33,327.29l-2.63-1.24s-2.84-5.49-3.49-5.27-.85,1.83.29,4.36l-3.49-1s-7.59,3.5-7.25,4a1.75,1.75,0,0,0,2.61.75c1.65-.85,3.81-1.84,3.81-1.84l4.09,1.17-5.27.67-5,4.51a2.43,2.43,0,0,0,3-.08L363,336.06l4,.22v-7.44Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.07,333.29c.06,0,.3-.34.76-.85a3.63,3.63,0,0,1,.94-.72,3.93,3.93,0,0,1,1.39-.37,18.22,18.22,0,0,0,3.86-.66,19.6,19.6,0,0,0-3.91.26,3.89,3.89,0,0,0-1.53.45,3.26,3.26,0,0,0-1,.86A2.48,2.48,0,0,0,350.07,333.29Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.09,333.81c.05,0,.09-.27.45-.35s.95-.13,1.56-.19a13.77,13.77,0,0,0,2.26-.23,4.53,4.53,0,0,0-2.3-.18,6.94,6.94,0,0,0-1.62.34.65.65,0,0,0-.39.4C352,333.74,352.06,333.81,352.09,333.81Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.9,308.72l-2.55,8.65L401.15,310c.59-1.81,3.27-9.87,8.39-22.66a22,22,0,0,1,16.79-13.54,96.14,96.14,0,0,1,15.51-1.52c9.09.1,22.46,5.78,24.25,14.68,1.38,6.8.05,18.8.05,33.38L465,348.23l-46.55,1.57Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M466.09,313.92c-5.66,1.16-11.48,0-17.25-.35-3.5-.21-7.38-.59-10.15,1.56-2.19,1.71-3.07,4.58-3.71,7.28-2.41,10.32-2.85,17.23-3.39,27.81l28,1.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M418.71,278.49s.47.07,1.24.37a6.42,6.42,0,0,1,2.68,2.17,9,9,0,0,1,1.6,4.85,30,30,0,0,1-.49,6.38,108.08,108.08,0,0,1-2.6,11.41c-.38,1.4-.7,2.55-.94,3.43a7.37,7.37,0,0,0-.3,1.27,7.07,7.07,0,0,0,.45-1.23c.26-.8.63-1.95,1.06-3.39a87,87,0,0,0,2.73-11.43,29.25,29.25,0,0,0,.46-6.47,9.2,9.2,0,0,0-1.74-5,6.4,6.4,0,0,0-2.86-2.15,5.46,5.46,0,0,0-.95-.22C418.83,278.48,418.71,278.47,418.71,278.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.66,307.83a16.26,16.26,0,0,0,2.28,1.31c1.44.75,3.45,1.74,5.71,2.76s4.34,1.87,5.86,2.45a14,14,0,0,0,2.49.84,19.07,19.07,0,0,0-2.39-1.1c-1.48-.65-3.54-1.54-5.79-2.56s-4.28-2-5.75-2.65A17.6,17.6,0,0,0,401.66,307.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.24,351.92a16.59,16.59,0,0,0-6.77,22.22L428,443.7l18.69-11.29-31.46-62.8L438,354.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.57,348.47l-55.62,2a16.59,16.59,0,0,0-16,16.84l2.31,79.43,23.39,0-.78-75.1,46.7-1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.87,374.27a3.86,3.86,0,0,1,.07.74q0,.8.09,2.1c.07,1.83.14,4.48.21,7.76.14,6.55.23,15.6.28,25.59s.1,19,.13,25.59c0,3.24,0,5.87.05,7.76,0,.88,0,1.58,0,2.11a3.91,3.91,0,0,1,0,.74,4,4,0,0,1-.07-.74c0-.53-.05-1.23-.09-2.11-.07-1.83-.14-4.48-.21-7.75-.14-6.55-.23-15.6-.28-25.6s-.1-19-.13-25.59c0-3.23,0-5.86,0-7.75V375A3.81,3.81,0,0,1,396.87,374.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.66,298.07H450.83a12.26,12.26,0,0,0-12.26,12.26V369H405a8.49,8.49,0,0,0-8.49,8.49h76.75v0a7,7,0,0,0,6.71-7V310.33A12.26,12.26,0,0,0,467.66,298.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.46,300c.14,0,.26,17.25.26,38.53s-.12,38.53-.26,38.53-.26-17.25-.26-38.53S443.32,300,443.46,300Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.33,439.14V377.56h-5.47v61.58c-3.34,6.58-11.19,11-20.75,14.68h48.76C454,449.8,445,446.71,441.33,439.14Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.27,431.16l.16-.36.49-1.05a27.63,27.63,0,0,0,1.44-4.18,36.94,36.94,0,0,0-.13-16.15,87.45,87.45,0,0,0-3-10.85c-1.27-3.85-2.74-7.93-4-12.35a47.84,47.84,0,0,1-1.94-14.2c.18-5,1.67-10,3.3-15s3.32-9.88,3.83-14.8a22.54,22.54,0,0,0-2.72-13.67c-2.16-4-4.88-7.4-6.92-10.93a38,38,0,0,1-4.17-10.51,39.25,39.25,0,0,1-.26-16.28,30,30,0,0,1,1.7-5.75,2.81,2.81,0,0,1-.1.38c-.09.27-.2.63-.35,1.1a43.17,43.17,0,0,0-1,4.3A39.56,39.56,0,0,0,120,307a37.72,37.72,0,0,0,4.18,10.38c2,3.49,4.77,6.89,7,10.93a22.94,22.94,0,0,1,2.8,13.94c-.51,5-2.21,9.92-3.84,14.91s-3.1,10-3.29,14.89a47.83,47.83,0,0,0,1.9,14.06c1.19,4.39,2.64,8.48,3.9,12.34a84.93,84.93,0,0,1,2.94,10.91,36.54,36.54,0,0,1,0,16.27A24.3,24.3,0,0,1,134,429.8c-.23.43-.4.77-.54,1A1.46,1.46,0,0,1,133.27,431.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.61,321.07s-4.14-13.23,3.28-21a.46.46,0,0,1,.79.23C131.07,302.5,131.57,309.16,126.61,321.07Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.09,304.5a12.3,12.3,0,0,1-.28,2.44c-.28,1.68-.6,3.66-1,5.84s-.66,4.16-.92,5.84a14.1,14.1,0,0,1-.44,2.41,10.15,10.15,0,0,1,.07-2.46c.14-1.51.4-3.59.78-5.87s.77-4.34,1.1-5.83A10.17,10.17,0,0,1,129.09,304.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.47,352.29s2.53-13.63,12.72-17a.45.45,0,0,1,.58.57C144.1,338,141.43,344.08,131.47,352.29Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.41,338.8a11.88,11.88,0,0,1-1.39,2l-3.56,4.72-3.55,4.72a12.49,12.49,0,0,1-1.52,1.93,10.33,10.33,0,0,1,1.22-2.14c.83-1.27,2-3,3.43-4.83s2.72-3.47,3.69-4.63A10.45,10.45,0,0,1,141.41,338.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.71,386.49s-1.53-13.78,7.23-20a.46.46,0,0,1,.73.38C136.64,369.12,135.86,375.75,128.71,386.49Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.31,370.7a12.11,12.11,0,0,1-.74,2.34l-2,5.55c-.76,2.08-1.44,4-2,5.56a13.87,13.87,0,0,1-.89,2.28,10,10,0,0,1,.54-2.4c.42-1.46,1.08-3.45,1.88-5.62s1.59-4.11,2.19-5.5A10.49,10.49,0,0,1,134.31,370.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.39,420.9s-1-13.83,7.94-19.7a.45.45,0,0,1,.71.4C144.93,403.82,143.91,410.41,136.39,420.9Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,405.31a12.47,12.47,0,0,1-.83,2.32c-.64,1.58-1.4,3.43-2.23,5.47s-1.59,3.9-2.23,5.48a12.62,12.62,0,0,1-1,2.25,10.89,10.89,0,0,1,.63-2.38c.47-1.44,1.2-3.4,2.09-5.54s1.73-4.06,2.38-5.43A10.76,10.76,0,0,1,142.55,405.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.66,309.45S108.37,303,108.12,292.3a.46.46,0,0,1,.72-.4C110.67,293.16,115.73,297.52,120.66,309.45Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.68,296a12.21,12.21,0,0,1,1.53,1.93l3.46,4.79,3.48,4.78a12.68,12.68,0,0,1,1.4,2,9.86,9.86,0,0,1-1.69-1.79c-1-1.16-2.26-2.82-3.61-4.7s-2.52-3.61-3.34-4.89A10.87,10.87,0,0,1,110.68,296Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.86,337.87s-12.66-5.66-13.55-16.36a.45.45,0,0,1,.69-.43C122.9,322.23,128.21,326.26,133.86,337.87Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.08,325a12.45,12.45,0,0,1,1.64,1.82l3.75,4.58c1.41,1.7,2.68,3.24,3.76,4.56a13.29,13.29,0,0,1,1.52,1.92,10.28,10.28,0,0,1-1.79-1.68c-1-1.1-2.43-2.68-3.89-4.48s-2.74-3.45-3.64-4.67A11,11,0,0,1,123.08,325Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.57,369.58s-8.69-10.81-4.61-20.74a.45.45,0,0,1,.81-.07C123.94,350.66,126.84,356.67,126.57,369.58Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.82,353.24a12.31,12.31,0,0,1,.63,2.38c.37,1.66.79,3.62,1.26,5.78s.9,4.1,1.27,5.77a13.24,13.24,0,0,1,.48,2.41,9.49,9.49,0,0,1-.83-2.32c-.43-1.46-.94-3.49-1.43-5.76s-.87-4.32-1.11-5.81A11,11,0,0,1,122.82,353.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.18,406.89S122.62,401,121.91,390.3a.46.46,0,0,1,.7-.42C124.49,391.06,129.74,395.18,135.18,406.89Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.62,393.87a12.72,12.72,0,0,1,1.61,1.86l3.68,4.63c1.37,1.73,2.62,3.29,3.68,4.62a14.25,14.25,0,0,1,1.49,2,10.8,10.8,0,0,1-1.77-1.72c-1-1.12-2.38-2.72-3.81-4.54s-2.68-3.49-3.56-4.73A10.88,10.88,0,0,1,124.62,393.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,352.36s0,.11,0,.31,0,.53,0,.89q-.06,1.24-.15,3.36c-.16,3-.39,7.08-.66,12h0v0c-.9,5-3.45,10.57-6.89,16-2.52,4-5.15,7.6-7.43,11a76.63,76.63,0,0,0-5.57,9.22,38.49,38.49,0,0,0-2.61,6.76c-.22.83-.39,1.47-.48,1.91a3.72,3.72,0,0,1-.19.67,3.25,3.25,0,0,1,.08-.69c.07-.45.2-1.1.39-1.94a35.79,35.79,0,0,1,2.48-6.87,72.45,72.45,0,0,1,5.5-9.32c2.26-3.39,4.89-7,7.39-11,3.42-5.37,6-10.85,6.89-15.79v0c.34-4.93.63-9,.84-12,.11-1.4.2-2.52.27-3.35,0-.35.07-.64.09-.88A1.16,1.16,0,0,1,160.2,352.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.72,383.9s5.32-12.8-1.37-21.19a.45.45,0,0,0-.8.15C150,365,148.86,371.59,152.72,383.9Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.76,367.17a11.36,11.36,0,0,1,.42,2.42c.19,1.51.4,3.59.56,5.9s.25,4.41.24,5.92a10.94,10.94,0,0,1-.14,2.46,12.72,12.72,0,0,1-.22-2.44c-.12-1.7-.25-3.7-.4-5.9s-.29-4.2-.41-5.9A11.47,11.47,0,0,1,151.76,367.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.72,383.9s5.32-12.8-1.37-21.19a.45.45,0,0,0-.8.15C150,365,148.86,371.59,152.72,383.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M136.25,414.76s4.26-13.19-3.09-21a.46.46,0,0,0-.79.22C132,396.15,131.39,402.8,136.25,414.76Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,398.17a10.7,10.7,0,0,1,.62,2.38c.31,1.48.69,3.54,1,5.83s.6,4.37.72,5.88a10,10,0,0,1,0,2.46,13.86,13.86,0,0,1-.41-2.42c-.25-1.68-.55-3.66-.87-5.84s-.63-4.17-.89-5.85A12.13,12.13,0,0,1,133.92,398.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.25,414.76s4.26-13.19-3.09-21a.46.46,0,0,0-.79.22C132,396.15,131.39,402.8,136.25,414.76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M159.5,368.25s11.36-7.95,10.21-18.62a.46.46,0,0,0-.76-.3C167.3,350.82,162.85,355.79,159.5,368.25Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.5,368.25s11.36-7.95,10.21-18.62a.46.46,0,0,0-.76-.3C167.3,350.82,162.85,355.79,159.5,368.25Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M167.66,353.61a11.32,11.32,0,0,1-.95,2.27c-.64,1.37-1.58,3.25-2.68,5.28s-2.16,3.85-3,5.13a9.58,9.58,0,0,1-1.44,2,14.73,14.73,0,0,1,1.13-2.18c.82-1.49,1.77-3.24,2.83-5.18s2-3.7,2.82-5.2A11.79,11.79,0,0,1,167.66,353.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.83,401.68s13.7-2.14,17.37-12.22a.46.46,0,0,0-.55-.61C155.51,389.47,149.32,392,140.83,401.68Z",
    style: {
      fill: "#06446F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.83,401.68s13.7-2.14,17.37-12.22a.46.46,0,0,0-.55-.61C155.51,389.47,149.32,392,140.83,401.68Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M154.6,392.13a11,11,0,0,1-1.85,1.63c-1.18.94-2.85,2.21-4.74,3.55s-3.63,2.5-4.92,3.3a9.79,9.79,0,0,1-2.18,1.15,12.3,12.3,0,0,1,2-1.46l4.82-3.41,4.82-3.43A12.74,12.74,0,0,1,154.6,392.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.76 426.9 123.76 453.8 148.67 453.8 145.44 426.9 127.76 426.9",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.43,435.23a95,95,0,0,1-10,.26,95,95,0,0,1-10-.26,98.3,98.3,0,0,1,10-.26A98.3,98.3,0,0,1,146.43,435.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.93,437.37a101.61,101.61,0,0,1-10.38.26,101.33,101.33,0,0,1-10.37-.26c0-.14,4.64-.26,10.37-.26S146.93,437.23,146.93,437.37Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryLane);
export default __webpack_public_path__ + "static/media/StoryLane.273c7f64c95911cf0221fcb1bd30cd99.svg";
export { ForwardRef as ReactComponent };